<script lang="ts">
	//Hooks
	import { createEventDispatcher } from 'svelte';
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Button, Modal, Text, Alert, Container } from '@Shelly/shelly-design-system';

	export let showModal = false;
	export let isOffline;
	export let title = '';
	export let btnTexts: {
		cancelText?: string;
		saveText?: string;
	} = null;

	const dispatch = createEventDispatcher();
	export let warning = false;
	export let hideSlotAdditionalInfo = false;

	export const open = (showWarning = false) => {
		warning = showWarning;
		showModal = true;
	};

	export const close = () => {
		showModal = false;
		dispatch('close');
	};

	const confirm = () => {
		showModal = false;
		dispatch('confirm');
	};
</script>

<!-- TODO add tranaslation to modal title label_confirmation -->
<Modal
	on:close={() => close()}
	{showModal}
	backdropClose={true}
	title={title ? title : $format('label_confirmation', { default: 'Confirmation' })}
>
	<svelte:fragment slot="content">
		<Container padding="0">
			{#if warning}
				<slot name="warning">
					<Alert
						type="warning"
						heading={$format('warning_disable_connection', {
							default:
								'WARNING: If you disable this connection, you will lose connection to your device.',
						})}
					/>
				</slot>
			{:else}
				<Text>
					<slot />
				</Text>
			{/if}

			{#if $$slots.additionalInfo && !hideSlotAdditionalInfo}
				<slot name="additionalInfo" />
			{/if}
		</Container>
	</svelte:fragment>
	<div class="d-flex justify-content-end" slot="footer">
		<Button
			disabled={isOffline}
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			on:click={() => close()}
		>
			{btnTexts?.cancelText
				? btnTexts.cancelText
				: $format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			disabled={isOffline}
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={confirm}
		>
			{btnTexts?.saveText ? btnTexts.saveText : $format('button_confirm', { default: 'Confirm' })}
		</Button>
	</div>
</Modal>
